import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { mergeMap, take, catchError } from 'rxjs/operators';
import { IDataService } from './data-service.interface';

@Injectable()
export class DataResolverService {
  constructor(@Inject('IDataService') private dataService: IDataService, private router: Router) {}

  resolve(): Observable<any> {
    return this.dataService.getDataFromServer().pipe(
      take(1),
      mergeMap((data) => {
        if (data) {
          return of(data);
        } else {
          localStorage.removeItem('tracking-token');
          this.router.navigate(['/']);
          return of(null);
        }
      }),
      catchError((error) => {
        localStorage.removeItem('tracking-token');
        const queryParams = {};
        if (error.code === 401) {
          Object.assign(queryParams, { redirectPath: location.pathname });
        } else {
          Object.assign(queryParams, { error: error.message, logout: true });
        }
        this.router.navigate(['/'], { queryParams });
        return of(null);
      })
    );
  }
}
